export const isDrawingViewerPath = (pathname = "") => {
  const match = String(pathname).match(/^\/dashboard\/drawings\/([^/]+)$/);
  return Boolean(match && match[1] !== "new");
};

export const isIfcStandalonePath = (pathname = "") =>
  /^\/dashboard\/projects\/[^/]+\/ifc-viewer\/?$/.test(pathname);

export const isImmersiveViewerPath = (pathname = "") =>
  isDrawingViewerPath(pathname) || isIfcStandalonePath(pathname);

/** Tailwind `xl` = 1280. Phone + tablet chrome below this (iPad portrait and most landscape). */
export const IMMERSIVE_VIEWER_MOBILE_MAX = 1279;
export const IMMERSIVE_VIEWER_MOBILE_MQ = `(max-width: ${IMMERSIVE_VIEWER_MOBILE_MAX}px)`;

/** Fill the dashboard main pane under the 4rem header. Never 100vw. */
export const IMMERSIVE_VIEWER_SHELL_CLASS =
  "h-[calc(100dvh-4rem)] max-h-[calc(100svh-4rem)] min-w-0 w-full max-w-full overflow-hidden overflow-x-hidden overscroll-none";
